<template>
  <div>
    <div class="px-2">
      <v-btn style="text-transform: capitalize" small color="info" @click="printPraph">
        <v-icon class="mr-2">fas fa-print</v-icon>
        Печатать график погашения
      </v-btn>
    </div>
    <div v-if="printData" style="display: none" id="contract-credit-print-page">
      <div class="a4__landscape">

        <div class="block__wrapper">
          <div class="block__column" :class="i === 1 ? 'block__left' : 'block__right'" v-for="i in 2">
            <h2 class="block__title">Шартнома № {{ printData.credit_number }}</h2>
            <p class="block__date bold__text">Шартнома санаси - {{ printData.created_at }}</p>

            <h1 class="block__huge-text">
              {{ printData.first_name }} {{ printData.last_name }} {{ printData.mid_name }}
            </h1>

            <div class="table__main">
              <table>
                <thead>
                <tr>
                  <th width='80'>№</th>
                  <th colspan="2">Махсулот номи</th>
                  <th>Суммаси</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td class="border__bottom"></td>
                  <td colspan="2" class="border__bottom">{{ printData.details }}</td>
                  <td class="border__bottom">{{ printData.old_amount |money}}</td>
                </tr>
                <tr>
                  <td class="border__none border-top__none"></td>
                </tr>
                <tr>
                  <td width='100'
                      class="border__bottom border-right__none">Махсулот суммаси:
                  </td>
                  <td class="border__bottom border-left__none">{{ printData.old_amount |money}}</td>
                  <td class="border__bottom border-right__none">Бугунги кундаги карз суммаси:</td>
                  <td class="border__bottom border-left__none">{{ printData.debt|money }}</td>
                </tr>
                <tr>
                  <td class="border__none border-top__none"></td>
                </tr>

                <tr>
                  <td class="border-right__none">Олдиндан тулов:</td>
                  <td class="border-left__none">{{ printData.initial_payment |money}}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <h2 class="block__title">Туловлар жадвали</h2>

            <div class="table__main">
              <table>
                <thead>
                <th>Тулов санаси</th>
                <th>Ойлик тулови</th>
                <th>Туланган сумма</th>
                <th>Колдик сумма</th>
                </thead>
                <tbody>
                <tr v-for="graph in printData.graphs">
                  <td>{{ graph.payment_date }}</td>
                  <td>{{ graph.must_be_paid |money}}</td>
                  <td>{{ graph.paid |money}}</td>
                  <td>{{ graph.debt |money}}</td>
                </tr>
                <tr>
                  <td class="bold__text">Жами тулов</td>
                  <td class="bold__text">{{ printData.all_must_be_paid |money}}</td>
                  <td class="bold__text">{{ printData.all_paid |money}}</td>
                  <td class="bold__text">{{ printData.all_debt |money}}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <p class="block__text agreement__mt" style="text-align: left">
              <b>{{ printData.mko_name }}</b>
            </p>
            <p class="block__text agreement__mt" style="text-align: left; margin-top: 0">
              <b>Мурожаат учун телефон: </b>
              <span>{{ printData.mko_phone }}</span>
            </p>
            <p class="block__text agreement__mt" style="text-align: right; margin-top: 0">
              <b>Сана: </b>
              <span>{{ printData.now }}</span>
            </p>
            <p class="block__text agreement__mt"
               style="text-align: left">
              <b>Танишдим:</b>
              <span>_____________________</span>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "PrintGraph",
  props: {
    credit_id: {required: true}
  },
  data() {
    return {
      printData: null
    }
  },
  methods: {
    getData() {
      return this.$http.get(`admin/credits/auto-payment-print/${this.credit_id}`).then(({data: {data}}) => {
        this.printData = data
      })
    },
    async printPraph() {
      try {
        this.$showLoading()
        await this.getData()
        this.$nextTick(() => {
          this.$htmlToPaper('contract-credit-print-page')
        })
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    }
  }

}
</script>

<style scoped>

</style>